define('SageDotCom/DataLayer/Events/Ccaas/ccaasEvent',[
        "jquery",
        "SageDotCom/DataLayer/Events/eventBase"
    ],
    function ($, EventBase) {
        function CcaaSEvent(chatUniqueId, action, category, label, name, level2, level3, level4) {
            EventBase.call(this);

            const eventAction = action;
            const eventCategory = category || "component";
            const eventLabel = label;
            const eventName = name;
            const eventLevel1 = chatUniqueId || "chat-console";
            const eventLevel2 = level2 || "";
            const eventLevel3 = level3;
            const eventLevel4 = level4;

            this.props = {
                'event_action': eventAction,
                'event_category': eventCategory,
                'event_label': eventLabel,
                'event_name': eventName,
                'event_name_level_1': eventLevel1,
                'event_name_level_2': eventLevel2,
                'event_name_level_3': eventLevel3,
                'event_name_level_4': eventLevel4,
                'event_non-int': "0"
            };
        }

        CcaaSEvent.prototype = Object.create(EventBase.prototype);
        return CcaaSEvent;
    });
